import Head from 'next/head'
import { createClient } from 'services/prismic'

import Divider from 'components/Divider'
import PrismicPage from 'components/PrismicPage'
import SimpleCollectionCard from 'components/SimpleCollectionCard'
import Spacer from 'components/Spacer'

import { CollectionsGroup, Column, Columns, Root } from './index.style'

const collectionToCollectionCardProps = (collection) => ({
  handle: collection.handle,
  title: collection.title,
  imageUrl: collection.image.src,
})

export default function Shop({ document, clothingCollections, accessoriesCollections, footwearCollections }) {
  return (
    <>
      <Head>
        <title>Shop - The Armoury</title>
      </Head>
      <Spacer y="insetY" />
      <PrismicPage document={document} />
      <Root>
        <CollectionsGroup>
          <Divider text="Clothing" />
          <Spacer y={8} />
          <Columns>
            {clothingCollections.map(collectionToCollectionCardProps).map((collection) => (
              <Column key={collection.handle}>
                <SimpleCollectionCard {...collection} />
              </Column>
            ))}
          </Columns>
        </CollectionsGroup>
        <CollectionsGroup>
          <Divider text="Accessories" />
          <Spacer y={8} />
          <Columns>
            {accessoriesCollections.map(collectionToCollectionCardProps).map((collection) => (
              <Column key={collection.handle}>
                <SimpleCollectionCard {...collection} />
              </Column>
            ))}
          </Columns>
        </CollectionsGroup>
        <CollectionsGroup>
          <Divider text="Footwear" />
          <Spacer y={8} />
          <Columns>
            {footwearCollections.map(collectionToCollectionCardProps).map((collection) => (
              <Column key={collection.handle}>
                <SimpleCollectionCard {...collection} />
              </Column>
            ))}
          </Columns>
        </CollectionsGroup>
      </Root>
    </>
  )
}

export async function getStaticProps({ previewData }) {
  const prismic = createClient({ previewData })
  const document = await prismic.getPage('shop')

  const shopCollections = await (await fetch(`${process.env.API_URI}/collections/categories`)).json()

  return {
    props: {
      document,
      clothingCollections: shopCollections.clothing,
      accessoriesCollections: shopCollections.accessories,
      footwearCollections: shopCollections.footwear,
    },
  }
}
